import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";
import { useTranslation } from "react-i18next"

const CustomerPriceGroupAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label, disabled = false, load = true, infoText, error, helperText, selectFirst }) => {
    const { t } = useTranslation();


    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.priceGroup")}
            url="/autocompleteApi/Pricegroup"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={disabled}
            selectFirst={ selectFirst}
        />
    );
};

export default CustomerPriceGroupAutoComplete;
